import type { CoverSheetConfigCard } from '../../types';

export const counterpartyTCCard = {
  id: 'counterpartyTC',
  innerTitle: "Counterparty's Transaction Coordinator",
  outerTitle: "Counterparty's Transaction Coordinators",
  isAddable: true,
  addableTitle: "Counterparty's Transaction Coordinator",
  addText: 'TC',
  addByDefault: true,
  maxAddable: 2,
  entity: 'contacts',
  entityType: 'counterpartyTransactionCoordinator',
  isCollapsible: true,
  syncsWithGoogleContacts: true,
  displayFields: [
    {
      name: 'contacts.counterpartyTransactionCoordinator.x.firstName',
      type: 'name',
    },
    {
      name: 'contacts.counterpartyTransactionCoordinator.x.lastName',
      type: 'name',
    },
    {
      name: 'contacts.counterpartyTransactionCoordinator.x.email',
      type: 'email',
    },
    {
      name: 'contacts.counterpartyTransactionCoordinator.x.cellPhone',
      type: 'phone',
    },
  ],
  collapsedName: [
    'contacts.counterpartyTransactionCoordinator.x.firstName',
    'contacts.counterpartyTransactionCoordinator.x.lastName',
  ],
  layout: [
    [
      {
        name: 'contacts.counterpartyTransactionCoordinator.x.firstName',
        size: 50,
      },
      {
        name: 'contacts.counterpartyTransactionCoordinator.x.lastName',
        size: 50,
      },
    ],
    [
      {
        name: 'contacts.counterpartyTransactionCoordinator.x.email',
        size: 50,
      },
      {
        name: 'contacts.counterpartyTransactionCoordinator.x.cellPhone',
        size: 50,
      },
    ],
  ],
  fields: {
    firstName: {
      name: 'contacts.counterpartyTransactionCoordinator.x.firstName',
      entity: 'contacts',
      entityType: 'counterpartyTransactionCoordinator',
      type: 'autofill',
      label: 'First Name',
      placeholderText: '',
      action: {
        name: 'autofill',
        provider: 'googleContacts',
        label: {
          primary: 'fullName',
          secondary: 'email',
        },
        props: [
          {
            from: 'googleContactId',
            to: 'contacts.counterpartyTransactionCoordinator.x.googleContactId',
          },
          {
            from: 'contactSource',
            to: 'contacts.counterpartyTransactionCoordinator.x.contactSource',
          },
          {
            from: 'firstName',
            to: 'contacts.counterpartyTransactionCoordinator.x.firstName',
          },
          {
            from: 'lastName',
            to: 'contacts.counterpartyTransactionCoordinator.x.lastName',
          },
          {
            from: 'email',
            to: 'contacts.counterpartyTransactionCoordinator.x.email',
          },
          {
            from: 'cellPhone',
            to: 'contacts.counterpartyTransactionCoordinator.x.cellPhone',
          },
          {
            from: 'licenseNumber',
            to: 'contacts.counterpartyTransactionCoordinator.x.licenseNumber',
          },
          {
            from: 'companyName',
            to: 'contacts.counterpartyTransactionCoordinator.x.companyName',
          },
          {
            from: 'avatar',
            to: 'contacts.counterpartyTransactionCoordinator.x.avatar',
          },
          {
            from: 'street1',
            to: 'contacts.counterpartyTransactionCoordinator.x.street1',
          },
          {
            from: 'street2',
            to: 'contacts.counterpartyTransactionCoordinator.x.street2',
          },
          {
            from: 'city',
            to: 'contacts.counterpartyTransactionCoordinator.x.city',
          },
          {
            from: 'state',
            to: 'contacts.counterpartyTransactionCoordinator.x.state',
          },
          {
            from: 'zip',
            to: 'contacts.counterpartyTransactionCoordinator.x.zip',
          },
          {
            from: 'brokerage.street1',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.street1',
          },
          {
            from: 'brokerage.street2',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.street2',
          },
          {
            from: 'brokerage.city',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.city',
          },
          {
            from: 'brokerage.state',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.state',
          },
          {
            from: 'brokerage.zip',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.zip',
          },
          {
            from: 'brokerage.licenseNumber',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.licenseNumber',
          },
          {
            from: 'brokerage.companyName',
            to: 'contacts.counterpartyTransactionCoordinator.x.brokerage.companyName',
          },
        ],
      },
    },
    lastName: {
      name: 'contacts.counterpartyTransactionCoordinator.x.lastName',
      entity: 'contacts',
      entityType: 'counterpartyTransactionCoordinator',
      type: 'text',
      label: 'Last Name',
      placeholderText: '',
    },
    email: {
      name: 'contacts.counterpartyTransactionCoordinator.x.email',
      entity: 'contacts',
      entityType: 'counterpartyTransactionCoordinator',
      type: 'text',
      label: 'Email',
      placeholderText: '',
      validation: [
        {
          type: 'email',
          message: 'Invalid Email',
        },
      ],
    },
    cellPhone: {
      name: 'contacts.counterpartyTransactionCoordinator.x.cellPhone',
      entity: 'contacts',
      entityType: 'counterpartyTransactionCoordinator',
      type: 'phoneWithExt',
      label: 'Phone',
      placeholderText: '',
      validation: [
        {
          type: 'phone',
          message: 'Invalid phone number',
        },
      ],
    },
  },
} satisfies CoverSheetConfigCard;
